enum UsersSubmenuEnum {
    Demography,
    Configuration,
    Practice,
    Tools
}

export { UsersSubmenuEnum };
